import { ObjectHelper } from "Code/Helpers/ObjectHelper";

export class SaveProgress {
    public static Show() {
        const elem1: any = document.getElementById('progress-overlayer');
        if (ObjectHelper.ObjectIs(elem1)) {
            elem1.style.display = 'block';
        }
    }

    public static Hide() {
        const elem1: any = document.getElementById('progress-overlayer');
        if (ObjectHelper.ObjectIs(elem1)) {
            elem1.style.display = 'none';
        }
    }
}